import React from "react"
import PropTypes from "prop-types"

import Flex from "@irati/ui/src/Flex"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import {Body} from "@irati/ui/src/Typography"
import History from "@irati/utils/history"

import {VIEW_TEAM} from "../../routes/routeConfig"

interface Props extends InjectIntl {}

const NoManagers: React.FC<Props> = ({formatMessage}, context) => {
  const handleOnClick = () => {
    History.push({pathname: VIEW_TEAM}, context)
  }
  return (
    <Flex alignItems="center" direction="column">
      <img src={formatMessage({id: "admin.components.noUsers.img"})} alt="no_results" />
      <Body marginTop={3} width="515px">
        <FormattedMessage id="admin.components.noUsers.noManagers" />
      </Body>
      <Button primary small onClick={handleOnClick} marginTop={3}>
        <FormattedMessage id="admin.components.noUsers.assignManagers" />
      </Button>
    </Flex>
  )
}

NoManagers.contextTypes = {
  appPath: PropTypes.string
}

export default injectIntl(NoManagers)
